export const DASHBOARD_ROUTES = {
	dashboard: "/dashboard",
} as const;
